import { useContext } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Devider,
  Flex,
  Text,
  Button,
  ModalContext,
  DashPlaceholder,
} from 'dash-ui';
import {
  DEFAULT_MEDIA_FOLDERS_LIST,
  DEFAULT_SLIDESHOW_FOLDER_NAME,
  SystemMediaFoldersTypesEnum,
} from 'dash-common';

import { GetMediaFolderByIdQuery } from 'gql/generated.graphql';
import { stickyTopBarStyles } from 'containers/properties/helpers/stickyTopBarStyles';

const PageWrapper = styled(Box)<{ top?: number }>`
  ${stickyTopBarStyles}
`;

const MediaFolderDetails = ({
  folder,
}: {
  folder: GetMediaFolderByIdQuery['getMediaFolderById'];
}) => {
  const { toggleModal, setPayload } = useContext(ModalContext);
  const navigate = useNavigate();
  const isDefaultFolder = DEFAULT_MEDIA_FOLDERS_LIST.includes(
    folder.systemFolderType as SystemMediaFoldersTypesEnum
  );

  return (
    <PageWrapper w="100%" pos="sticky" top={107}>
      <Flex flexDirection="row" justifyContent="space-between" p={4} w="100%">
        <Flex>
          <DashPlaceholder
            icon="folder"
            iconProps={{ size: 34 }}
            size={80}
            mr={3}
          />
          <Text lg bold>
            {folder.folderName}
          </Text>
        </Flex>
        <Flex>
          <Button
            onClick={() => {
              toggleModal(true, 'SetFolderNameModal');
              setPayload({ media: folder });
            }}
            variation="outline"
            disabled={folder.folderName === DEFAULT_SLIDESHOW_FOLDER_NAME}
            square
            medium
            icon="edit"
            mr={3}
          />
          <Button
            onClick={() => {
              toggleModal(true, 'RemoveFolderModal');
              setPayload({ media: folder, onConfirm: () => navigate(-1) });
            }}
            disabled={
              folder.folderName === DEFAULT_SLIDESHOW_FOLDER_NAME ||
              isDefaultFolder
            }
            variation="outline"
            square
            medium
            icon="trash"
          />
        </Flex>
      </Flex>
      <Devider />
    </PageWrapper>
  );
};

export default MediaFolderDetails;
